interface ExamResultInterface {
  title: string;
  subtitle: string;
  info: string;
  whatDoNext: string;
  imageResult: string;
  class: string;
  urlVideo: string;
}

const Positive: ExamResultInterface = {
  title: 'Reagente',
  subtitle: 'resultado indicativo de sorologia positiva para HIV',
  info: '',
  whatDoNext:
    'Você deve procurar um serviço de saúde pública para confirmar o diagnóstico acompanhado de um médico',
  imageResult: '',
  class: 'positive-with-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780474426?h=c813d0c4da&autoplay=1&muted=1&api=1',
};

const NegativeUntilThreeDays: ExamResultInterface = {
  title: 'Não Reagente',
  subtitle: 'resultado indicativo de sorologia negativa para HIV',
  info: 'Este teste é indicado a partir de 30 dias da suspeita de contato com o vírus. Você informou risco de exposição a menos de 3 dias. Aguarde 30 dias para realizar um novo teste. Busque por uma unidade de saúde para ter mais informações sobre a (PEP). <a href="http://antigo.aids.gov.br/pt-br/onde-encontrar-pep" target="_blank" >Clique aqui e saiba onde encontrar</a>',
  whatDoNext:
    'Busque por centro de testagem e aconselhamento próximos a você. Nele você terá acesso a uma rede de apoio profissional para este momento.',
  imageResult: '',
  class: 'positive-without-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780495971?h=9bad50da21&autoplay=1&muted=1',
};

const NegativeWithInterval: ExamResultInterface = {
  title: 'Não Reagente',
  subtitle: 'resultado indicativo de sorologia negativa para HIV',
  info: 'Este teste é indicado a partir de 30 dias da suspeita de contato com o vírus. Você informou risco de exposição entre 4 e 29 dias. Aguarde 30 dias para realizar um novo teste.',
  whatDoNext:
    'Busque por centro de testagem e aconselhamento próximos a você. Nele você terá acesso a uma rede de apoio profissional para este momento.',
  imageResult: 'urlNegativeImage',
  class: 'negative-with-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780524234?h=4c93aa35f8&autoplay=1&muted=1',
};

const NegativeOverThirtyDays: ExamResultInterface = {
  title: 'Não Reagente',
  subtitle: 'resultado indicativo de sorologia negativa para HIV',
  info: 'Você informou risco de exposição a mais de 30 dias. Se mesmo com este resultado não reagente você ainda suspeita de infecção pelo HIV, recomendamos que você faça um novo teste em 30 dias.',
  whatDoNext:
    'Busque por centro de testagem e aconselhamento próximos a você. Nele você terá acesso a uma rede de apoio profissional para este momento.',
  imageResult: '',
  class: 'negative-without-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780539621?h=814d9e661c&autoplay=1&muted=1',
};

const InvalidUntilThreeDays: ExamResultInterface = {
  title: 'Inválido',
  subtitle: 'resultado não conclusivo para sorologia do HIV',
  info: 'Este teste é indicado a partir de 30 dias da suspeita de contato com o vírus. Você informou risco de exposição a menos de 3 dias. Aguarde 30 dias para realizar um novo teste. Busque por uma unidade de saúde para ter mais informações sobre a (PEP). <a href="http://antigo.aids.gov.br/pt-br/onde-encontrar-pep" target="_blank" >Clique aqui e saiba onde encontrar</a>',
  whatDoNext:
    'Você deve fazer um novo teste, e o encontrará em farmácias físicas ou online. Ou ainda, você pode retirar na rede pública de saúde.',
  imageResult: '',
  class: 'positive-without-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780511684?h=56cc8500d2&autoplay=1&muted=1',
};

const InvalidWithInterval: ExamResultInterface = {
  title: 'Inválido',
  subtitle: 'resultado não conclusivo para sorologia do HIV',
  info: '',
  whatDoNext:
    'Você deve fazer um novo teste, e o encontrará em farmácias físicas ou online. Ou ainda, você pode retirar na rede pública de saúde.',
  imageResult: '',
  class: 'Invalid-with-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780532169?h=b630a65b47&autoplay=1&muted=1',
};

const InvalidOverThirtyDays: ExamResultInterface = {
  title: 'Inválido',
  subtitle: 'resultado não conclusivo para sorologia do HIV',
  info: '',
  whatDoNext:
    'Você deve fazer um novo teste, e o encontrará em farmácias físicas ou online. Ou ainda, você pode retirar na rede pública de saúde.',
  imageResult: '',
  class: 'negative-without-symptoms',
  urlVideo:
    'https://player.vimeo.com/video/780532169?h=b630a65b47&autoplay=1&muted=1',
};

export {
  ExamResultInterface,
  Positive,
  NegativeOverThirtyDays,
  NegativeUntilThreeDays,
  NegativeWithInterval,
  InvalidOverThirtyDays,
  InvalidUntilThreeDays,
  InvalidWithInterval,
};
